/** pino level name -> Google Cloud Logging severity. */
export const LEVEL_TO_SEVERITY = {
    trace: 'DEBUG',
    debug: 'DEBUG',
    info: 'INFO',
    warn: 'WARNING',
    error: 'ERROR',
    fatal: 'CRITICAL',
};
/** Map a level label to a severity, defaulting to DEFAULT for unknown labels. */
export function toSeverity(label) {
    return LEVEL_TO_SEVERITY[label] ?? 'DEFAULT';
}
//# sourceMappingURL=severity.js.map